(function () {
  'use strict';

  function initSvOfferBlock(block) {

    var packs = {
      a: {
        boxes: 1,
        anchor:   block.dataset.anchorA   || '$49.00',
        sub:      block.dataset.subA      || '$34.00',
        ot:       block.dataset.otA       || '$40.00',
        badge:    block.dataset.badgeA    || 'Save 30%',
        perBar:   block.dataset.perBarA   || '$2.83 / bar',
        perBarOt: '$3.00 / bar',
        sellingPlan: block.dataset.subPlanA || ''
      },
      b: {
        boxes: 2,
        anchor:   block.dataset.anchorB   || '$98.00',
        sub:      block.dataset.subB      || '$59.00',
        ot:       block.dataset.otB       || '$80.00',
        badge:    block.dataset.badgeB    || 'Save 40%',
        perBar:   block.dataset.perBarB   || '$2.46 / bar',
        perBarOt: '$3.00 / bar',
        sellingPlan: block.dataset.subPlanB || ''
      },
      c: {
        boxes: 3,
        anchor:   block.dataset.anchorC   || '$147.00',
        sub:      block.dataset.subC      || '$81.00',
        ot:       block.dataset.otC       || '$120.00',
        badge:    block.dataset.badgeC    || 'Save 45%',
        perBar:   block.dataset.perBarC   || '$2.25 / bar',
        perBarOt: '$3.00 / bar',
        sellingPlan: block.dataset.subPlanC || ''
      }
    };

    var freq = 'b';
    var selectedMode = 'sub';
    var flavorQty = [0, 0, 0];
    var dialogWired = false;

    function qs(sel) { return block.querySelector(sel); }
    function setText(el, val) { if (el) el.textContent = val; }

    function findDialog() {
      var el = block.nextElementSibling;
      while (el) {
        if (el.tagName === 'DIALOG') return el;
        el = el.nextElementSibling;
      }
      return null;
    }

    var freqBtns   = block.querySelectorAll('.sv-freq-opt');
    var elSubWas   = qs('.sv-sub-was');
    var elSubPrice = qs('.sv-sub-price');
    var elSubPb    = qs('.sv-sub-pb');
    var elSubBoxes = qs('.sv-sub-boxes');
    var elBadge    = qs('.sv-offer-badge');
    var elCtaText  = qs('.sv-cta-text');
    var ctaBtn     = qs('.sv-cta-btn');
    var otpCard    = qs('.sv-offer-card--ot');
    var subCard    = qs('.sv-offer-card--sub');
    var otpBody    = qs('.sv-otp-body');

    var backBtn, tallyEl, flavorInstEl, addBtns, qtyCtrls, qtyNums, flavorRows, confirmBtn, confirmText;

    /* ── OTP BODY VISIBILITY — class-based for CSS transition ── */
    function showOtpBody(show) {
      if (!otpBody) return;
      if (show) {
        otpBody.classList.add('sv-otp-body--open');
      } else {
        otpBody.classList.remove('sv-otp-body--open');
      }
    }

    // Hide on init
    showOtpBody(false);

    freqBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        freq = btn.dataset.freq;
        freqBtns.forEach(function (b) {
          b.classList.toggle('active', b.dataset.freq === freq);
        });
        render();
      });
    });

    /* ── OFFER SELECTION ── */
    var RADIO_ON  = 'border:2px solid #000;border-radius:50%;width:22px;height:22px;min-width:22px;background:#fff;margin-top:3px;flex-shrink:0;display:block;box-shadow:inset 0 0 0 4px #fff,inset 0 0 0 11px #434B92;';
    var RADIO_OFF = 'border:2px solid #ccc;border-radius:50%;width:22px;height:22px;min-width:22px;background:#fff;margin-top:3px;flex-shrink:0;display:block;box-shadow:none;';

    function setRadio(el, on) {
      if (!el) return;
      el.setAttribute('style', on ? RADIO_ON : RADIO_OFF);
    }

    function selectSub() {
      selectedMode = 'sub';
      if (subCard) subCard.classList.remove('sub-unselected');
      if (subCard) subCard.classList.add('active');
      if (otpCard) otpCard.classList.remove('ot-active');
      setRadio(subCard ? subCard.querySelector('.sv-radio') : null, true);
      setRadio(otpCard ? otpCard.querySelector('.sv-radio') : null, false);
      showOtpBody(false);
      render();
    }

      function selectOtp() {
        selectedMode = 'otp';
        if (subCard) subCard.classList.add('sub-unselected');
        if (subCard) subCard.classList.remove('active');
        if (otpCard) otpCard.classList.add('ot-active');
        setRadio(subCard ? subCard.querySelector('.sv-radio') : null, false);
        setRadio(otpCard ? otpCard.querySelector('.sv-radio') : null, true);
        showOtpBody(true);
        render();
      }

    if (subCard) subCard.addEventListener('click', selectSub);
    if (otpCard) otpCard.addEventListener('click', selectOtp);

    function render() {
      var d = packs[freq];
      var bl = d.boxes === 1 ? '1 Pack' : d.boxes + ' Packs';
      setText(elSubWas,   d.anchor);
      setText(elSubPrice, d.sub);
      setText(elSubPb,    d.perBar);
      setText(elSubBoxes, bl + ' Delivered Monthly');
      setText(elBadge,    d.badge);

      // Update OTP card prices
      var elOtpPrice = block.querySelector('.sv-otp-price');
      var elOtpWas   = block.querySelector('.sv-otp-was');
      var elOtpPb    = block.querySelector('.sv-otp-pb');
      if (elOtpPrice) elOtpPrice.textContent = d.ot;
      if (elOtpWas)   elOtpWas.textContent   = d.anchor;
      if (elOtpPb)    elOtpPb.textContent     = d.perBarOt;

      // Update CTA text based on selected mode
      if (elCtaText) {
        var price = selectedMode === 'otp' ? d.ot : d.sub;
        if (selectedMode === 'otp') {
          elCtaText.innerHTML = 'Select Flavors &mdash; ' + price + ' \u2192';
        } else {
          var anchor = d.anchor;
          elCtaText.innerHTML = 'Select Flavors &mdash; <span class="sv-cta-was">' + anchor + '</span> ' + price + ' \u2192';
        }
      }
    }

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        openDialog(selectedMode === 'otp');
      });
    }

    function openDialog(isOtp) {
      var dlg = findDialog();
      if (!dlg) return;

      flavorQty = [0, 0, 0];
      dlg.dataset.otpMode = isOtp ? '1' : '0';

      if (!dialogWired) {
        backBtn      = dlg.querySelector('.sv-back-btn');
        tallyEl      = dlg.querySelector('.sv-tally-val');
        flavorInstEl = dlg.querySelector('.sv-flavor-inst');
        addBtns      = Array.prototype.slice.call(dlg.querySelectorAll('.sv-add-btn'));
        qtyCtrls     = Array.prototype.slice.call(dlg.querySelectorAll('.sv-qty-ctrl'));
        qtyNums      = Array.prototype.slice.call(dlg.querySelectorAll('.sv-qty-num'));
        flavorRows   = Array.prototype.slice.call(dlg.querySelectorAll('.sv-flavor-row'));
        confirmBtn   = dlg.querySelector('.sv-confirm-btn');
        confirmText  = dlg.querySelector('.sv-confirm-text');

        if (backBtn) backBtn.addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('close', function () { document.body.style.overflow = ''; });
        wireFlavorBtns(dlg);
        wireConfirmBtn();
        dialogWired = true;
      }

      resetFlavors();
      updateTally(isOtp);
      dlg.showModal();
      document.body.style.overflow = 'hidden';
    }

    function wireFlavorBtns(dlg) {
      addBtns.forEach(function (btn, idx) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('disabled')) return;
          var total = flavorQty.reduce(function (a, b) { return a + b; }, 0);
          if (total >= packs[freq].boxes) return;
          flavorQty[idx]++;
          btn.style.display = 'none';
          if (qtyCtrls[idx]) qtyCtrls[idx].classList.add('show');
          if (qtyNums[idx])  qtyNums[idx].textContent = flavorQty[idx];
          if (flavorRows[idx]) flavorRows[idx].classList.add('has-qty');
          updateAddBtns();
          var isOtp = dlg.dataset.otpMode === '1';
          updateTally(isOtp);
        });
      });

      dlg.querySelectorAll('.sv-qty-btn--minus').forEach(function (btn, idx) {
        btn.addEventListener('click', function () {
          var next = flavorQty[idx] - 1;
          if (next < 0) return;
          flavorQty[idx] = next;
          if (qtyNums[idx]) qtyNums[idx].textContent = next;
          if (next === 0) {
            if (addBtns[idx])   addBtns[idx].style.display = '';
            if (qtyCtrls[idx])  qtyCtrls[idx].classList.remove('show');
            if (flavorRows[idx]) flavorRows[idx].classList.remove('has-qty');
          }
          updateAddBtns();
          var isOtp = dlg.dataset.otpMode === '1';
          updateTally(isOtp);
        });
      });

      dlg.querySelectorAll('.sv-qty-btn--plus').forEach(function (btn, idx) {
        btn.addEventListener('click', function () {
          var total = flavorQty.reduce(function (a, b) { return a + b; }, 0);
          if (total >= packs[freq].boxes) return;
          flavorQty[idx]++;
          if (qtyNums[idx]) qtyNums[idx].textContent = flavorQty[idx];
          updateAddBtns();
          var isOtp = dlg.dataset.otpMode === '1';
          updateTally(isOtp);
        });
      });
    }

    function wireConfirmBtn() {
      if (!confirmBtn) return;
      confirmBtn.addEventListener('click', function () {
        if (confirmBtn.disabled) return;
        var dlg = findDialog();
        var isOtp = dlg && dlg.dataset.otpMode === '1';
        var sellingPlan = isOtp ? null : packs[freq].sellingPlan;
        var variantIds  = block.dataset.variantIds ? block.dataset.variantIds.split(',') : [];
        var items = [];

        flavorQty.forEach(function (qty, idx) {
          if (qty > 0 && variantIds[idx]) {
            var item = { id: parseInt(variantIds[idx].trim(), 10), quantity: qty };
            if (sellingPlan) item.selling_plan = parseInt(sellingPlan, 10);
            items.push(item);
          }
        });

        if (items.length === 0) return;
        confirmBtn.disabled = true;
        var spinner = confirmBtn.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          confirmBtn.disabled = false;
          if (spinner) spinner.classList.add('hidden');
          if (dlg) dlg.close();
          refreshCartDrawer();
        })
        .catch(function (err) {
          console.error('Supervibe add to cart error:', err);
          confirmBtn.disabled = false;
          if (spinner) spinner.classList.add('hidden');
        });
      });
    }

    function resetFlavors() {
      flavorQty = [0, 0, 0];
      if (addBtns)    addBtns.forEach(function (btn) { btn.style.display = ''; btn.classList.remove('disabled'); });
      if (qtyCtrls)   qtyCtrls.forEach(function (c) { c.classList.remove('show'); });
      if (qtyNums)    qtyNums.forEach(function (el) { el.textContent = '0'; });
      if (flavorRows) flavorRows.forEach(function (row) { row.classList.remove('has-qty'); });
    }

    function updateAddBtns() {
      if (!addBtns) return;
      var total = flavorQty.reduce(function (a, b) { return a + b; }, 0);
      var full  = total >= packs[freq].boxes;
      addBtns.forEach(function (btn) {
        if (btn.style.display !== 'none') btn.classList.toggle('disabled', full);
      });
    }

    function updateTally(isOtp) {
      var d         = packs[freq];
      var total     = flavorQty.reduce(function (a, b) { return a + b; }, 0);
      var remaining = d.boxes - total;
      var ap        = isOtp ? d.ot : d.sub;
      var shipVal   = isOtp ? ' + $5.00 shipping' : '';

      if (tallyEl) {
        tallyEl.textContent = total + ' / ' + d.boxes;
        tallyEl.className   = 'sv-tally-val' + (total === d.boxes ? ' complete' : total > d.boxes ? ' over' : '');
      }

      if (confirmBtn && confirmText) {
        if (total === d.boxes) {
          confirmBtn.disabled     = false;
          confirmText.textContent = 'Add to Cart \u2014 ' + ap + shipVal + ' \u2192';
        } else {
          confirmBtn.disabled     = true;
          confirmText.textContent = 'Add ' + remaining + ' more box' + (remaining === 1 ? '' : 'es');
        }
      }
    }

    function refreshCartDrawer() {
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser     = new DOMParser();
          var doc        = parser.parseFromString(html, 'text/html');
          var cartDrawer = document.querySelector('cart-drawer');
          var newDrawer  = doc.querySelector('cart-drawer');
          if (cartDrawer && newDrawer) {
            cartDrawer.replaceWith(newDrawer);
            newDrawer.classList.add('active');
          }
        })
        .catch(function (err) { console.error('Cart drawer refresh error:', err); });
    }

    /* ============================================================
       STARTER PACK TOGGLE
       ============================================================ */
    var starterToggle = document.getElementById('sv-starter-toggle-' + block.dataset.blockId);
    var starterBack    = document.getElementById('sv-starter-back-' + block.dataset.blockId);
    var stepMain       = block.querySelector('.sv-step--1');
    var stepStarter    = document.getElementById('sv-step-starter-' + block.dataset.blockId);
    var starterCta     = document.getElementById('sv-starter-cta-' + block.dataset.blockId);

    /* ── Main product image swap ── */
    var gallerySectionId = block.dataset.gallerySectionId;
    var starterImageSrc  = block.dataset.starterImage;
    var starterImageAlt  = block.dataset.starterImageAlt;
    var mainImgEl        = null;
    var mainImgOriginal  = null;

    function getMainImg() {
      if (mainImgEl) return mainImgEl;
      var slide = document.querySelector('#Slider-Gallery-' + gallerySectionId + ' .slider__slide.is-active img');
      if (slide) mainImgEl = slide;
      return mainImgEl;
    }

    function swapToStarterImage() {
      var img = getMainImg();
      if (!img || !starterImageSrc) return;
      if (!mainImgOriginal) {
        mainImgOriginal = {
          src: img.getAttribute('src'),
          srcset: img.getAttribute('srcset'),
          alt: img.getAttribute('alt')
        };
      }
      img.removeAttribute('srcset');
      img.setAttribute('src', starterImageSrc);
      if (starterImageAlt) img.setAttribute('alt', starterImageAlt);
    }

    function restoreMainImage() {
      var img = getMainImg();
      if (!img || !mainImgOriginal) return;
      img.setAttribute('src', mainImgOriginal.src);
      if (mainImgOriginal.srcset) img.setAttribute('srcset', mainImgOriginal.srcset);
      if (mainImgOriginal.alt) img.setAttribute('alt', mainImgOriginal.alt);
    }

    if (starterToggle && stepStarter && stepMain) {
      starterToggle.addEventListener('click', function () {
        stepMain.classList.add('hidden');
        stepStarter.classList.remove('hidden');
        swapToStarterImage();
      });
    }
    if (starterBack && stepStarter && stepMain) {
      starterBack.addEventListener('click', function () {
        stepStarter.classList.add('hidden');
        stepMain.classList.remove('hidden');
        restoreMainImage();
      });
    }
    if (starterCta) {
      starterCta.addEventListener('click', function () {
        var variantId = parseInt(starterCta.dataset.starterVariantId, 10);
        if (!variantId) return;
        starterCta.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          starterCta.disabled = false;
          refreshCartDrawer();
        })
        .catch(function (err) {
          console.error('Supervibe starter add to cart error:', err);
          starterCta.disabled = false;
        });
      });
    }

    // Init
    render();
    updateTally(false);
    selectSub(); // Set sub as selected by default
  }

  function init() {
    document.querySelectorAll('.sv-offer-block').forEach(initSvOfferBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.sv-offer-block').forEach(initSvOfferBlock);
  });

}());
